import { render, staticRenderFns } from "./ItemPromocao.vue?vue&type=template&id=264d54fc&scoped=true"
import script from "./ItemPromocao.vue?vue&type=script&lang=js"
export * from "./ItemPromocao.vue?vue&type=script&lang=js"
import style0 from "./ItemPromocao.vue?vue&type=style&index=0&id=264d54fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d54fc",
  null
  
)

export default component.exports